import basics1 from './basics1';
import basics2 from './basics2';
import basics3 from './basics3';
import basics4 from './basics4';
import flow1 from './flow1';
import './flow2';
import './multiples1';
import './multiples2';
import './misc1';
import './misc2';
export const levels = {
    basics1,
    basics2,
    basics3,
    basics4,
    flow1,
    /*flow2,

    multiples1,
    multiples2,

    misc1,
    misc2,*/
};
export const firstLevel = 'basics1';
export const levelGroups = [
    {
        title: 'The Basics',
        levels: Object.keys(levels).filter(key => key.startsWith('basics')),
    },
    {
        title: 'Go with the Flow (Control)',
        levels: Object.keys(levels).filter(key => key.startsWith('flow')),
    },
    /*	{
            title: 'Dealing with Multiples',
            levels: Object.keys( levels ).filter( key => key.startsWith( 'multiples' ) ),
        },
        {
            title: 'Misc scraps',
            levels: Object.keys( levels ).filter( key => key.startsWith( 'misc' ) ),
        },*/
];
